import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useAddBoard, useTranslations } from "providers";
import React from "react";

import { AddBoardForm } from "./AddBoardForm";

export const AddBoardPanel: React.FC = () => {
  const i18n = useTranslations();
  const { isDirty, isValid, isSubmitting, confirmUnsaved, setConfirmUnsaved, handleSave, handleClose } = useAddBoard();
  const saveButtonDisabled = !isDirty || !isValid;

  return (
    <>
      <SlidingPanel
        isOpen={true}
        onCancel={() => handleClose(true)}
        onClose={() => handleClose()}
        onSave={() => handleSave()}
        panelClassName=""
        panelContainerClassName=""
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        header={<h1>{i18n.AddBoardPanel_Header}</h1>}
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
      >
        <AddBoardForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmUnsaved}
        setIsOpen={setConfirmUnsaved}
        onCancel={() => setConfirmUnsaved(false)}
      />
    </>
  );
};
